(ns frontend.ui.page.lp-report-editor.step-4-pending-approval.view
  (:require
   [common.localization :as loc]
   [frontend.ui.page.lp-report-editor.common.event :as common-event]
   [frontend.ui.page.lp-report-editor.common.modal.pdf-preview-modal :as pdf-preview-modal]
   [frontend.ui.page.lp-report-editor.common.style :as common-style]
   [frontend.ui.page.lp-report-editor.common.view :as common-view :refer
    [continue-button footer next-button preview-pdf-button]]
   [frontend.ui.page.lp-report-editor.event :as editor-event]
   [frontend.ui.page.lp-report-editor.step-4-pending-approval.event :as event]
   [frontend.ui.page.lp-report-editor.step-4-pending-approval.sub :as sub]
   [frontend.ui.page.lp-report-editor.sub :as editor-sub]
   [herb.core :refer [<class]]
   [re-frame.core :as rf]
   [ui.components.button.view :as button]))

(defn step-footer
  [report feeder?]
  (let [main-report @(rf/subscribe [::editor-sub/lp-report])
        approve-access? @(rf/subscribe [::sub/approve-access?])
        wip? @(rf/subscribe [::editor-sub/reports-not-approved?])]
    [footer
     {:left-content
      [:<>
       [continue-button]
       [:div
        [pdf-preview-modal/view
         {:on-close #(rf/dispatch [::common-event/close-pdf-preview])
          :report   report
          :feeder?  feeder?}]
        [preview-pdf-button
         {:on-click #(rf/dispatch [::common-event/open-pdf-preview report feeder?])}]]
       (when-let [burned-pdfs (seq (:lp-report/burned-pdfs main-report))]
         [:div
          [button/secondary-hollow
           {:on-click #(rf/dispatch [::editor-event/open-burned-pdf burned-pdfs])}
           (loc/tr :open-burned-pdf)]])]
      :right-content
      [:<>
       (when approve-access?
         [:div
          {:class (<class common-style/spacing-left)}
          (if (not= :lp-report.step/pending-approval (:lp-report/step main-report))
            [next-button [::editor-event/activate-step :lp-report.step/approved]]
            [:<>
             [button/primary-solid
              {:disabled? (boolean wip?)
               :on-click  #(rf/dispatch [::event/approve-cycle (:db/id main-report)])}
              (loc/tr :approve)]])])]}]))

(defn pending-approval
  []
  [common-view/report-viewer sub/report-tab-path step-footer])

(defn body
  []
  [pending-approval])
